// extracted by mini-css-extract-plugin
module.exports = {"border":"pixelated-border_border__Ys83J","secondary":"pixelated-border_secondary__XvN1b","flip":"pixelated-border_flip__HaNNa"};